import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from '@mui/material';
import {useNavigate} from 'react-router';

import TwoColumnsContainer from '../components/TwoColumnsContainer';
import IntroImage from '../assets/img/dg2.a32ccd93.jpg';

const IndexPage = () => {
  const navigate = useNavigate();

  const onVerifyDocument = () => navigate('/public');

  const onBrowseDocuments = () => navigate('/private');

  return (
    <TwoColumnsContainer
      leftColumn={
        <Stack
          direction={'row'}
          sx={{
            // ml: 60,
            // backgroundColor: 'pink',
            height: '100%',
            maxWidth: 600,
            marginLeft: {
              xs: '',
              md: 'auto',
            },
            position: 'relative',
            display: 'flex',
          }}
          justifyContent={{
            xs: 'center',
            // md: "flex-start"
          }}
          alignItems={{
            xs: 'center',
            // md: 'flex-start',
          }}>
          <Card
            variant="outlined"
            sx={{
              flex: 1,
              ml: 3,
              p: 2,
              mr: 3,
              minHeight: 422,
              width: {
                md: 526,
              },
              display: 'flex',
              flexDirection: 'column',
              // width: '100%',
            }}>
            <CardHeader
              // color="secondary.main"
              title={'Verificación y consulta de documentos firmados'}
              titleTypographyProps={{
                variant: 'h6',
                fontWeight: 'bold',
                sx: {
                  // background: `linear-gradient(rgba(143, 198, 0, .71), rgba(143, 198, 0, .71)), url(${SmallIntroImage})`,
                  // backgroundSize: 'cover',
                  // backgroundRepeat: 'no-repeat',
                  // backgroundPosition: '0% 58%;',
                },
              }}
            />

            <CardContent
              sx={{
                display: 'flex',
                // backgroundColor: 'yellow',
                flexDirection: 'column',
                flexGrow: 1,
              }}>
              <Typography>
                Usted puede verificar la validez de un documento firmado a
                través de su código de verificación o puede acceder a todos sus
                documentos firmados.
              </Typography>

              <Box
                display={'flex'}
                flexDirection={{
                  xs: 'column',
                  lg: 'row',
                }}
                alignItems={'center'}
                justifyContent={{
                  xs: 'center',
                  lg: 'space-evenly',
                }}
                flex={1}
                sx={{
                  // backgroundColor: 'pink',
                  height: '100%',
                }}>
                <Button variant="contained" onClick={onVerifyDocument}>
                  VERIFICAR DOCUMENTO
                </Button>

                <Button
                  variant="contained"
                  onClick={onBrowseDocuments}
                  sx={{
                    marginTop: {
                      xs: 2,
                      lg: 0,
                    },
                  }}>
                  VER MIS DOCUMENTOS
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Stack>
      }
      rightColumn={
        <img src={IntroImage} width={'100%'} height={'100%'} alt={'Imagen'} />
      }
    />
  );
};

export default IndexPage;
